import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FileItemGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S6};
  width: 100%;
`

interface FileItemProps {
  $hasError?: boolean
}

export const FileItem = styled.div<FileItemProps>`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  justify-content: space-between;
  min-width: 0;
  padding: ${Spacing.S8} ${Spacing.S12};
  border: 2px solid ${({ $hasError }) => ($hasError ? Color.Red700 : 'transparent')};
  border-radius: ${({ $hasError }) => ($hasError ? BorderRadius.R16 : BorderRadius.R8)};
  background-color: ${({ $hasError }) => ($hasError ? Color.White : Color.Grey50)};
`

export const FileNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${Spacing.S2};
  min-width: 0;
  overflow: hidden;
`

export const FileUploadProgress = styled.progress`
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  position: absolute;
  white-space: nowrap;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
`

export const FileIconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
`
